import { Input, Tooltip, Icon, Checkbox } from 'antd';
import React, { Component } from 'react';
import InputFormat from './../../../../../components/input-format';
import './RowItem.css';
import OrderHelper from './../../../../../services/orderHelper';
import { GSTPaidFlagCountries } from './../../../../../services/fieldRequired';

class RowItem extends Component {
    render() {
        const { itemData, pageType, shipment } = this.props
        
        let showGSTPaid = false
        if(GSTPaidFlagCountries.includes(shipment.DestinationCountryCH)){
            showGSTPaid = true
        }
        return (
            <tr id="row-item">
                <td>
                    <span className='no'>{this.props.no}</span>
                </td>
                <td id="item-sku-infor-order">
                    <Input
                        disabled
                        value={itemData.SKU}
                        name='sku'
                    />
                </td>
                <td style={{ width: '170px' }}>
                    <Input
                        disabled
                        value={itemData.ItemCode}
                        name='item code'
                    />
                </td>
                <td>
                    <Input
                        disabled
                        value={itemData.ItemName}
                        name='item name'
                    />
                </td>
                {/* <td className="text-center td-discount">
                    {!OrderHelper.item.priceIsDiscount(itemData) ? '' :
                        <Tooltip
                            title={OrderHelper.item.titleDiscount(itemData)}
                        >
                            <i className="fa fa-exclamation-circle icon-price-discount" aria-hidden="true"></i>
                        </Tooltip>
                    }
                </td> */}
                <td id='item-value-infor-order'>
                    <div className="box-item-value-info">
                        {
                        !OrderHelper.item.priceIsDiscount(itemData) ? '' :
                            <Tooltip
                                title={OrderHelper.item.titleDiscount(itemData)}
                            >
                                <Icon type="exclamation-circle" className="icon-iv-price-discount"/>
                            </Tooltip>
                        }
                        <Input
                            disabled
                            isRedstar={false}
                            value={OrderHelper.item.priceAdjusted(itemData)}
                            name='item value'
                        />
                    </div>
                    
                </td>
                <td className='qty-item'>
                    <Input
                        disabled
                        isRedstar={false}
                        value={itemData.QuantityOrderedIN}
                        name='qty'
                    />
                </td>
                <td>
                    <Input
                        disabled
                        isRedstar={false}
                        value={itemData.QuantityOrderedIN * OrderHelper.item.priceAdjusted(itemData)}
                        name='total value'
                    />
                </td>
                <td className='origin'>
                    <Input
                        disabled
                        value={itemData.CountryOfOriginCH}
                        name='origin'
                    />
                </td>
                <td>
                    <Input
                        disabled
                        value={itemData.OrderItemID}
                        name='channel order item'
                    />
                </td>
                {
                    showGSTPaid ? 
                    <td>
                        <Checkbox
                            disabled
                            checked={itemData.GSTPaid}
                            name='gst_paid'                    
                        />
                    </td>
                    : ""
                }
            </tr>
        )
    }
}

export default RowItem



// WEBPACK FOOTER //
// ./src/containers/shipments/detail-shipment/components/items/RowItem.js